import React, { useEffect, useState, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { CompanyContext } from "lib/context/CompanyContext";
import Session from "lib/api/Session";
import { setSelectedCompanyUuid } from "lib/local/SelectedCompany";
import logo from "../Login/logo.png";
import Validation from "components/common/Validation";

export default function TokenAuth(props) {
  const [error, setError] = useState("");
  const [validating, setValidating] = useState(true);
  const { setCompany } = useContext(CompanyContext);
  const history = useHistory();
  const { search } = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(search);

    // Get exchange token from query param
    const exchangeToken = urlParams.get("token");
    const redirectPath =
      urlParams.get("redirect") || "/admin/field-configuration";

    if (!exchangeToken) {
      setError("No authentication token provided.");
      setTimeout(() => history.replace("/login"), 3000);
      setValidating(false);
      return;
    }

    async function redeemAndValidateToken() {
      try {
        // Step 1: Redeem the exchange token for a JWT
        console.log(
          "Redeeming exchange token with API:",
          process.env.REACT_APP_API_BASE_URL
        );
        console.log(
          "Exchange token (first 20 chars):",
          exchangeToken?.substring(0, 20) + "..."
        );
        const redeemResponse = await Session.redeemExchangeToken(exchangeToken);
        console.log("Redeem response:", redeemResponse);

        if (redeemResponse.status !== 200 || !redeemResponse.data?.token) {
          // Handle redeem errors
          const errorMessages = {
            401: "Your exchange token has expired or is invalid. Please try again.",
            403: "Access denied. Please login with your credentials.",
            0: "Network error. Please check your connection.",
          };

          setError(
            errorMessages[redeemResponse.status] ||
              "Token exchange failed. Please try again."
          );
          setTimeout(() => {
            history.replace(`/login?error=${redeemResponse.status}`);
          }, 3000);
          return;
        }

        const jwtToken = redeemResponse.data.token;

        // Step 2: Validate the JWT by calling GET /authorization
        // console.log("Validating JWT (first 50 chars):", jwtToken + "...");
        const validateResponse = await Session.validateToken(jwtToken);
        console.log("Validation response:", validateResponse);

        if (validateResponse.status === 200 && validateResponse.data) {
          // JWT is valid! Store it in sessionStorage
          sessionStorage.setItem("token", jwtToken);

          // Set company context from response data
          if (validateResponse.data.user?.companies?.length) {
            setCompany(validateResponse.data.user.companies[0]);
          }

          // Optional default company for the Field Configuration pages
          const companyParam = urlParams.get("company_uuid");
          if (companyParam) setSelectedCompanyUuid(companyParam);

          // Redirect to destination
          history.replace(redirectPath);
        } else {
          // Handle validation errors
          const errorMessages = {
            401: "Your session has expired. Please login again.",
            403: "Access denied. Please login with your credentials.",
            0: "Network error. Please check your connection.",
          };

          setError(
            errorMessages[validateResponse.status] ||
              "Authentication failed. Please try again."
          );
          setTimeout(() => {
            history.replace(`/login?error=${validateResponse.status}`);
          }, 3000);
        }
      } catch (err) {
        setError("Network error. Please check your connection and try again.");
        setTimeout(() => history.replace("/login"), 3000);
      } finally {
        setValidating(false);
      }
    }

    redeemAndValidateToken();
  }, [search, history, setCompany]);

  return (
    <div className="app">
      <div className="app-body">
        <div className="app-body__content app-body__content--gradient">
          <div className="app-body__page app-body__page--sm">
            <div className="m-bot-auto m-top-auto">
              <div className="row m-top-20">
                <div className="col-xs-12 center-xs m-bot-20">
                  <img src={logo} alt="logo" />
                </div>
              </div>

              {validating && (
                <div className="row">
                  <div className="col-xs-12 text-center">
                    <h3>Authenticating...</h3>
                    <p>Please wait while we log you in.</p>
                  </div>
                </div>
              )}

              {error && (
                <>
                  <div className="row">
                    <div className="col-xs-12 text-center">
                      <Validation className="danger">{error}</Validation>
                    </div>
                  </div>
                  <div className="row m-top-20">
                    <div className="col-xs-12 text-center">
                      <p>Redirecting to login...</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
